import { MoovVariableDTO } from "../DTO/moovVariableDTO";
import { BasicRequest } from "./basicRequest";

export class UpdateMoovVariableRequest extends BasicRequest {
    
    public moovVariable!:MoovVariableDTO;

    constructor(){
        super();
    }
}